import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthSharedService } from '@core-lib/services';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard  {
	constructor(private authService: AuthSharedService) {}
	async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
		return this.authService?.isAuthenticated
	}
}
